<!--  -->
<template>
  <div class="dawbole">
    <div class="seraw">
      <div class="search_box">
        <el-input
          v-model="pageIfon.keywords"
          placeholder="请输入编号"
          style="width:300px;"
        />
        <el-select v-model="pageIfon.status" placeholder="请选择状态">
          <el-option label="全部" :value="0" />
          <el-option label="正常" :value="1" />
          <el-option label="已过期" :value="2" />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"

          @click.stop="search"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"

          @click.stop="dawe"
        >重置</el-button>
        <div />
      </div>
      <div>
        <el-button
          type="success"

          icon="el-icon-edit"
          @click="add"
        >新增</el-button>
      </div>
    </div>
    <el-table
      v-loading="loadingtable"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="html_no"
        label="编号"
        width="300"
        align="center"
      />
      <el-table-column
        prop="title"
        label="标题"
        width="200"
        align="center"
      >
        <template #default="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.title" placement="top">
            <span class="ellipsis">{{ scope.row.title }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="urls"
        label="网址"
        width="340"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row.urls) && scope.row.urls.length">
            <!-- 前 3 条 -->
            <div
              v-for="(item, index) in scope.row.urls.slice(0, 3)"
              :key="index"
              class="url-line"
            >
              <span class="url-text">{{ item }}</span>
              <i
                v-clipboard:copy="item"
                v-clipboard:success="onCopys"
                v-clipboard:error="onErrors"
                class="el-icon-document-copy"
              />
            </div>

            <!-- 展开区域 -->
            <div
              v-show="expandedIndex === scope.$index"
              ref="expandedList"
              class="more-urls"
            >
              <div
                v-for="(item, index) in scope.row.urls.slice(3)"
                :key="'more-' + index"
                class="url-line"
              >
                <span class="url-text">{{ item }}</span>
                <i
                  v-clipboard:copy="item"
                  v-clipboard:success="onCopys"
                  v-clipboard:error="onErrors"
                  class="el-icon-document-copy"
                />
              </div>
            </div>
            <!-- 展开更多按钮 -->
            <div>
              <span class="more-link" @click="toggleExpanded(scope.$index)">
                {{ expandedIndex === scope.$index ? '收起' : '...更多' }}
              </span>
            </div>
          </div>

          <!-- 单个 url -->
          <div v-else-if="scope.row.url">
            <div class="url-line">
              <span class="url-text">{{ scope.row.url }}</span>
              <i
                v-clipboard:copy="scope.row.url"
                v-clipboard:success="onCopys"
                v-clipboard:error="onErrors"
                class="el-icon-document-copy"
              />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="domain_click"
        label="域名点击数量"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            placement="top"
            popper-class="domain-tooltip"
          >
            <template #content>
              <div v-for="(item, index) in scope.row.domain_click" :key="index">
                {{ item.domain }}（{{ item.click_number }}次）
              </div>
            </template>

            <div class="ellipsis-list">
              <div
                v-for="(item, index) in limitedDomainClick(scope.row.domain_click)"
                :key="index"
              >
                {{ item.domain }}（{{ item.click_number }}次）
              </div>
              <span v-if="scope.row.domain_click.length > 3">...</span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="200"
        align="center"
      >
        <template #default="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top">
            <span class="ellipsis">{{ scope.row.remark }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="url"
        label="是否默认"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.html_default"
            :inactive-value="1"
            :active-value="2"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            :active-text="'是'"
            :inactive-text="'否'"
            @change="changewr(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1" type="success">
            <i class="el-icon-circle-check" style="color: #209c68;" /> {{ scope.row.status_text }}
          </div>
          <div v-else-if="scope.row.status === 2" type="danger">
            <i class="el-icon-circle-close" style="color: #8b0000;" /> {{ scope.row.status_text }}
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="expiration_time_text"
        label="过期时间"
        width="200"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
        fixed="right"
        width="100"
      >
        <template slot-scope="scope">
          <!-- <el-button
            type="warning"
            size="mini"
            @click="sendbookmoneyallr(scope.row,2)"
          >编辑</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="sendbookmoneyallr(scope.row,3)"
          >复用</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteItem(scope.row)"
          >删除</el-button>
          <el-button
            type="success"
            size="mini"
            @click="chuanhtml(scope.row)"
          >上传网页</el-button> -->
          <el-dropdown>
            <span class="el-dropdown-link">
              操作<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-edit" style="color:#209c68" @click.native="sendbookmoneyallr(scope.row,2)">编辑</el-dropdown-item>
              <el-dropdown-item icon="el-icon-edit-outline" style="color:#2aa1ff" @click.native="sendbookmoneyallr(scope.row,3)">复用</el-dropdown-item>
              <el-dropdown-item icon="el-icon-delete" style="color:#8b0000" @click.native="deleteItem(scope.row)">删除</el-dropdown-item>
              <el-dropdown-item icon="el-icon-upload" style="color:#997000" @click.native="chuanhtml(scope.row)">上传网页</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="设置内容"
      :visible.sync="relevanceVisible"
      :destroy-on-close="true"
      width="60%"
      :close-on-click-modal="false"
    >
      <aqdialog
        ref="aqdialogview"
        @updata="updata"
      />
    </el-dialog>
  </div>
</template>

<script>
import { iqiyipromotionlinklistone, iqiyipromotionlinkdelone, iqiyipromotionlinkcreatedetails, iqiyipromotionlikuploadyun, iqiyipromotionlichangedefault } from '@/api/officialaccount.js'
import { getQcConfig } from '@/api/sourceminiprogram.js'
import { uploadHtmlFile /* uploadHtmlFileone, uploadHtmlFilepinjie */ } from '@/utils/ObjectStoragehtml.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import aqdialog from './components/aqdialog.vue'
export default {
  components: {
    PaginationRight,
    aqdialog
  },
  data() {
    return {
      tableData: [],
      pageIfon: {
        page: 1,
        pageSize: 10,
        status: 0,
        keywords: null
      },
      total: null,
      number: '',
      dialogVisible: false,
      id: '',
      type: null,
      loadingtable: false,
      relevanceVisible: false,
      config: {},
      html_url: '',
      html_key: '',
      chuanshuzu: [],
      expandedIndex: null
    }
  },
  created() {
    this.turnlist()
    this.getconfig()
  },
  activated() {
    this.turnlist()
    this.getconfig()
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleExpanded(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index
    },
    handleClickOutside(event) {
      const containers = this.$refs.expandedList
      if (!Array.isArray(containers)) return
      const isOutside = containers.every(el => el && !el.contains(event.target))
      if (isOutside) this.expandedIndex = null
    },
    async getconfig() {
      const res = await getQcConfig({
        new: 1
      })
      this.config = res.data
    },
    search() {
      this.pageIfon.page = 1
      this.turnlist()
    },
    // 小程序转盘用户列表
    async turnlist() {
      this.loadingtable = true
      const data = await iqiyipromotionlinklistone(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loadingtable = false
      console.log('data', data)
    },
    dawe() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.status = 0
      this.pageIfon.keywords = null
      this.turnlist()
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.turnlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.turnlist()
    },
    exchange(id) {
      this.$router.push({
        path: '/exchange/index',
        query: {
          id: id,
          type: 1
        }
      })
    },
    sendbookmoneyallr(item, type) {
      this.relevanceVisible = true
      this.$nextTick(() => {
        this.$refs.aqdialogview.send(type, item)
      })
    },
    add() {
      this.relevanceVisible = true
      this.$nextTick(() => {
        this.$refs.aqdialogview.send(1)
      })
    },
    async updata(type, html_no, upload_html_number) {
      this.relevanceVisible = false
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        console.log('新增')
        this.turnlist()
      } else {
        console.log('编辑')
        // this.turnlist()
        try {
          await this.chuanhtml({ html_no: html_no, upload_html_number: upload_html_number }) // 等待 chuanhtml 执行完成
          console.log('编辑')
        } catch (error) {
          console.error('上传失败', error)
        }
      }
    },
    // 删除
    async deleteItem(row) {
      this.$confirm('是否确定删除该信息?删除后链接无法访问', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await iqiyipromotionlinkdelone({ html_no: row.html_no })
        this.turnlist()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    async chuanhtml(item) {
      try {
        this.chuanshuzu = []
        const res = await iqiyipromotionlinkcreatedetails({ html_no: item.html_no })
        const htmlText = res.data.detail.html_text
        const htmlNo = res.data.detail.html_no
        const title = res.data.detail.title
        const created_at_date = res.data.detail.created_at_date

        // const result = await uploadHtmlFile(
        //   htmlText,
        //   htmlNo,
        //   percent => {
        //     this.percentage = percent
        //   },
        //   this.config,
        //   title,
        //   created_at_date
        // )

        // 拼接的逻辑
        // const htmlParts = {
        //   headContent: res.data.detail.head_content,
        //   bodyContent: res.data.detail.body_content,
        //   scriptContent: res.data.detail.script_content
        // }

        // const result = await uploadHtmlFilepinjie(
        //   htmlParts,
        //   htmlNo,
        //   percent => {
        //     this.percentage = percent
        //   },
        //   this.config,
        //   title,
        //   created_at_date
        // )

        // console.log('上传成功：', result.fileUrl, result)
        // this.html_url = result.fileUrl
        // this.html_key = result.fileKey
        // console.log('this.html_key', this.html_key)
        // this.tongzhi(item.html_no)

        // 遍历 num 次，每次拼接编号
        for (let i = 1; i <= item.upload_html_number; i++) {
          const newHtmlNo = `${htmlNo}${this.generateCode()}`
          const result = await uploadHtmlFile(
            htmlText,
            newHtmlNo,
            percent => {
              this.percentage = percent
            },
            this.config,
            title,
            created_at_date
          )
          console.log(`第 ${i} 次上传成功：`, result.fileUrl)
          // 把 fileUrl 存入数组
          this.chuanshuzu.push(result.fileKey)
        }
        console.log('所有上传成功的链接：', this.chuanshuzu)

        // ✅ 所有上传完后统一通知
        this.tongzhi(item.html_no)
      } catch (err) {
        console.error('上传失败', err)
        this.$message.error('HTML 上传失败')
      }
    },
    tongzhi(html_no) {
      iqiyipromotionlikuploadyun({
        html_no: html_no,
        upload_html_nos: this.chuanshuzu
      }).then(res => {
        this.$message.success('HTML 上传成功')
        this.chuanshuzu = []
        this.turnlist()
      })
    },
    generateCode() {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const letter = letters[Math.floor(Math.random() * letters.length)]
      const digits = String(Math.floor(Math.random() * 1000)).padStart(3, '0')
      return letter + digits
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onErrors() {
      this.$message.error('复制失败')
    },
    // 限制最多显示3条
    limitedDomainClick(list) {
      return list.slice(0, 3)
    },
    // 拼接完整内容，用于 tooltip 显示
    fullDomainClick(list) {
      return list.map(item => `${item.domain}（${item.click_number}次）`).join('\n')
    },
    changewr(item) {
      iqiyipromotionlichangedefault({
        html_no: item.html_no,
        html_default: item.html_default === 1 ? 1 : 2
      }).then(res => {
        this.turnlist()
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dawbole {
  padding: 20px;
}
.seraw {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}
.ellipsis-list {
  max-height: 60px;
  overflow: hidden;
  line-height: 20px;
}
.ellipsis {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.url-line {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 4px;
}

.url-text {
  flex: 1;
  max-width: 290px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-icon-document-copy {
  margin-left: 6px;
  color: #165DFF;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
}

.more-link {
  color: #999;
  cursor: pointer;
  font-size: 13px;
}

.custom-tooltip {
  max-width: 400px;
  white-space: normal;
  word-break: break-all;
}

/* 自定义 tooltip 样式，确保一条一行显示 */
.el-tooltip__popper.domain-tooltip {
  white-space: normal;
  max-width: 400px;
  line-height: 1.6;
  word-break: break-all;
  padding: 8px 12px;
  font-size: 14px;
}
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
</style>
